import React from "react";
import { Link } from "react-router-dom";

const SayHello = () => {
 
	return (
		<div className="text-center pb-5 bg-dark text-white ">
			<h3 className="text-center mb-5">Contact me</h3>
			<p>Feel free to contact me.I will reply to you as soon as I can</p>
			<Link to="/contact">
				<button className="btn btn-success text-center text-white text-decoration-none">Say Hello</button>
			</Link>

		</div>
	);
};

export default SayHello;
